module.exports = __webpack_public_path__ + "img/shebei.2d0089c6.jpg";